document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".desktop_carousel__slider");
  if (!sliderEl) return;

  const countEl = document.querySelector(".slider-count");

  const swiper = new Swiper(".desktop_carousel__slider", {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 4,
    grabCursor: false,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: ".next-slide",
      prevEl: ".prev-slide",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 4,
      },
    },
    on: {
      init: updateCount,
      slideChange: updateCount,
    },
  });

  function updateCount() {
    if (!countEl) return;
    const total = this.slides.filter(
      (slide) => !slide.classList.contains("swiper-slide-duplicate")
    ).length;
    countEl.textContent = `${this.realIndex + 1} / ${total}`;
  }

  if (!isMobile()) {
    const swiperContainer = document.querySelector(".desktop_carousel__slider");
    if (!swiperContainer) return;

    const customCursor = document.createElement("div");
    customCursor.className = "custom-cursor desktop_carousel__cursor";
    customCursor.setAttribute("aria-hidden", "true");
    document.body.appendChild(customCursor);

    let isLeftSide = false;
    let isInsideSwiper = false;

    function hideDefaultCursor() {
      swiperContainer.classList.add("is-hovering-cursor");
      swiperContainer.style.cursor = "none";
      document.documentElement.style.cursor = "none";
      document.body.style.cursor = "none";
    }

    function restoreDefaultCursor() {
      swiperContainer.classList.remove("is-hovering-cursor");
      swiperContainer.style.cursor = "";
      document.documentElement.style.cursor = "";
      document.body.style.cursor = "";
    }

    document.addEventListener("mousemove", function (e) {
      customCursor.style.left = e.clientX + "px";
      customCursor.style.top = e.clientY + "px";

      if (isInsideSwiper) {
        const containerRect = swiperContainer.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const mouseX = e.clientX - containerRect.left;

        isLeftSide = mouseX < containerWidth / 2;

        customCursor.innerHTML = isLeftSide
          ? '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>';

        customCursor.style.display = "flex";
        hideDefaultCursor();
      }
    });

    swiperContainer.addEventListener("mouseenter", function () {
      isInsideSwiper = true;
      customCursor.style.display = "flex";
      hideDefaultCursor();
    });

    swiperContainer.addEventListener("mouseleave", function () {
      isInsideSwiper = false;
      customCursor.style.display = "none";
      restoreDefaultCursor();
    });

    swiperContainer.addEventListener("click", function () {
      if (!isInsideSwiper) return;
      if (isLeftSide) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    });
  }
});
